import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { OutOfCanvasUpdater } from "./OutOfCanvasUpdater";
export function loadOutModesUpdater(_x) {
  return _loadOutModesUpdater.apply(this, arguments);
}

function _loadOutModesUpdater() {
  _loadOutModesUpdater = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var refresh,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            refresh = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
            _context.next = 3;
            return engine.addParticleUpdater("outModes", function (container) {
              return new OutOfCanvasUpdater(container);
            }, refresh);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadOutModesUpdater.apply(this, arguments);
}